import { cn } from '@/lib/utils';
import * as React from 'react';

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('relative h-2 w-full overflow-hidden rounded-full bg-primary/20', className)}
      {...props}
    >
      <div
        className="h-full w-full flex-1 bg-primary transition-all duration-200"
        style={{ transform: `translateX(${value - 100}%)` }}
      />
    </div>
  )
);

Progress.displayName = 'Progress';

export { Progress };
